import { render, staticRenderFns } from "./CtaIvestorFullWidth.vue?vue&type=template&id=093c6878&scoped=true"
import script from "./CtaIvestorFullWidth.vue?vue&type=script&lang=js"
export * from "./CtaIvestorFullWidth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "093c6878",
  null
  
)

/* custom blocks */
import block0 from "./CtaIvestorFullWidth.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CImage: require('/vercel/path0/components/ui/c-image.vue').default,BaseButton: require('/vercel/path0/components/ui/BaseButton.vue').default})
